import { Pin, PinOff, X } from 'lucide-react';
import {
    ContextMenu,
    ContextMenuContent,
    ContextMenuItem,
    ContextMenuSeparator,
    ContextMenuTrigger,
} from '../ui/ContextMenu';
import NexusNavLink from '../navigation/NexusNavLink';
import { cn } from '../ui/utils';
import { useRecentPages } from '../../hooks/useRecentPages';

type RecentPagesProps = {
    pageTitle?: string | null;
};

export default function RecentPages({ pageTitle }: RecentPagesProps) {
    const { pages, currentPath, togglePin, removePage } = useRecentPages({
        pageTitle,
    });

    if (pages.length === 0) {
        return null;
    }

    return (
        <div className="nx-recent-pages" aria-label="Páginas recentes">
            <div className="nx-recent-pages-scroll">
                {pages.map((page) => {
                    const active = page.id === currentPath;

                    return (
                        <ContextMenu key={page.id}>
                            <ContextMenuTrigger asChild>
                                <span
                                    className={cn(
                                        'nx-recent-chip',
                                        active && 'nx-recent-chip--active',
                                        page.pinned && 'nx-recent-chip--pinned',
                                    )}
                                >
                                    <NexusNavLink
                                        href={page.href}
                                        className="nx-recent-chip-link"
                                        preserveScroll
                                        title={page.title}
                                    >
                                        {page.pinned && (
                                            <Pin
                                                className="nx-recent-chip-pin"
                                                size={11}
                                                strokeWidth={2.4}
                                                aria-hidden
                                            />
                                        )}
                                        <span>{page.title}</span>
                                    </NexusNavLink>
                                </span>
                            </ContextMenuTrigger>
                            <ContextMenuContent>
                                <ContextMenuItem
                                    onSelect={() => togglePin(page.id)}
                                >
                                    {page.pinned ? (
                                        <>
                                            <PinOff size={14} aria-hidden />
                                            Desafixar
                                        </>
                                    ) : (
                                        <>
                                            <Pin size={14} aria-hidden />
                                            Fixar
                                        </>
                                    )}
                                </ContextMenuItem>
                                {!page.pinned && (
                                    <>
                                        <ContextMenuSeparator />
                                        <ContextMenuItem
                                            onSelect={() => removePage(page.id)}
                                        >
                                            <X size={14} aria-hidden />
                                            Remover
                                        </ContextMenuItem>
                                    </>
                                )}
                            </ContextMenuContent>
                        </ContextMenu>
                    );
                })}
            </div>
        </div>
    );
}
